module.exports = __webpack_public_path__ + "img/calendar-illustration.b86e1144.svg";